import { Tip } from "@/types";
import { getActiveUniversity } from "@/utils/prize/universityUtils";
import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";

interface ScoreBoardProps {
  tips: Tip[];
}

export function ScoreBoardRight({ tips }: ScoreBoardProps) {
  const [totalVotes, setTotalVotes] = useState<number[]>([]);

  useEffect(() => {
    const calculateTotalVotes = async () => {
      const activeUniversity = await getActiveUniversity();
      const universityName = activeUniversity.name.toUpperCase();
      
      const voteTotals = tips.map(tip => {
        switch (universityName) {
          case 'UNSW':
            return tip.unsw_votes;
          case 'USYD':
            return tip.usyd_votes;
          case 'UOA':
            return tip.uoa_votes;
          default:
            return tip.unsw_votes; // Default to UNSW
        }
      });
      
      setTotalVotes(voteTotals);
    };

    calculateTotalVotes();
  }, [tips]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-0 animate-fade-in score_rotate">
      <div className="flex flex-col mb-6 mt-4">
        <img
          src="/imgs/board_title.png"
          alt="board title"
          className="w-[80%] h-auto mx-auto"
          id="board_title"
        />
      </div>
      <div className="w-full max-w-7xl relative flex">

        <div className="relative mx-6 ml-[9%]">
          <div className="flex flex-col space-y-12 w-full" style={{transform: 'scale(0.5)', width: '170%', marginLeft: '-46%', marginTop: '-240px'}}>
            {tips.slice(0, 5).map((tip, index) => (
              <div key={tip.id} className="relative">
                <div className="relative group transform transition-all duration-300 hover:scale-[1.02] mt-[-20px]">
                  <div className="relative p-[0px] mt-[-10px]">
                    <div className="p-[8px] rounded-[2.5em] shadow-[0_4px_10px_#005aaf] hover:shadow-[0px_12px_12px_#005aaf] transition-all duration-300"
                      style={{
                        background: 'linear-gradient(180deg, #1ab1e0, #0b74bc)',
                      }}
                    >
                      <div className="bg-[#01144b] rounded-[2em] p-2 relative">
                        <div className="bg-red rounded-[1.5em] p-6  py-2"
                          style={{
                            background: 'linear-gradient(10deg, rgba(2, 30, 113, 0.8), rgba(2, 30, 113, 0))'
                          }}
                        >
                          <div className="absolute bottom-6 ml-[-18px]">
                            <img src="/imgs/wing.png" alt="wing" className="w-auto h-[42px]" id="wing" />
                          </div>
                          <div className="relative">
                            <div className="flex flex-row items-center gap-4 text-left font-Quicksand">
                              <div className="w-32 h-32 bg-cover bg-center flex items-center justify-center"
                                style={{ backgroundImage: `url('/imgs/s${index + 1}.png')` }}
                              ></div>
                              <div className="flex flex-col space-y-2">
                                <h3 className="text-3xl font-bold text-vaseline-white">{tip.title}</h3>
                                <p className="text-vaseline-white text-xl font-medium leading-relaxed">
                                  {tip.content}
                                </p>
                                <div className="flex justify-end w-full absolute right-0 top-0 animate-float" style={{right: '-20%', top: '-40%', scale: '0.8' }}>
                                  <div className="flex items-center bg-[#19b4e8] px-3 py-3 rounded-2xl shadow-lg w-auto">
                                    <img src="/imgs/heart.png" alt="heart" className="w-auto h-[50px] mr-3 animate-heartbeat" id="heart" />
                                    <span className="text-4xl font-bold text-white font-Metric mr-2"
                                      style={{
                                        textShadow: '3px 3px 2px #0a93c0'
                                      }}>
                                      {totalVotes[index] || 0}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="w-[180px] flex flex-col items-center" style={{marginLeft: '-30%'}}>
          <div className="ele1"><img src="/imgs/heart2.png" alt="Live Your Best Lip!" className="w-[300px] h-auto floating4 mt-[-100px]" id="ele1B" /></div>
          <div className="ele2"><img src="/imgs/asterisk.png" alt="Live Your Best Lip!" className="w-[350px] h-auto floating3 mt-[100px] ml-[10px]" id="ele2B" /></div>
          <div className="ele4"><img src="/imgs/ball.png" alt="Live Your Best Lip!" className="w-[350px] h-auto floating3 mt-[100px] ml-[-30px]" id="ele4B" /></div>
          <div className="ele3"><img src="/imgs/doddle.png" alt="Live Your Best Lip!" className="w-[100px] h-auto floating4 mt-[100px] ml-[50px]" id="ele3B" /></div>
        </div>
      </div>
    </div>
  );
}
